const login = {
  name: 'login',
  path: '',
  component: resolve => require(['../../../pages/custom/login'], resolve)
}

export default login
